import { CardEvent } from './../events/types';
import { Moment } from 'moment';

export interface Week {
  id: number;
  startDate: Moment;
  endDate: Moment;
  open?: boolean;
  weekDays?: {
    monday: [];
    tuesday: [];
    wednesday: [];
    thursday: [];
    friday: [];
    saturday: [];
    sunday: [];
  };
  events?: CardEvent[];
}

export const enum WeekActionTypes {
  CALCULATE_WEEKS = '[weeks]CALCULATE_WEEKS',
  TOGGLE_WEEK = '[weeks]TOGGLE_WEEK'
}

export interface IWeekData {
  byId: { [id: number]: Week };
  allIds: number[];
  bySeasonId: { [id: number]: number[] };
}

export interface WeekState {
  readonly data: IWeekData;
}



// WEBPACK FOOTER //
// ./src/store/weeks/types.ts